import { required } from 'vuelidate/lib/validators'

const defaultEl = {
  id: null,
  name: '',
  swift: ''
};

export default {
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      swift: { required }
    }
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.bank.edit');
      }
      return this.$t('menu.bank.new');
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = {
          id: this.editEl.id,
          name: this.editEl.name,
          swift: this.editEl.swift
        };
        const self = this;
        this.ApiRequest.request('bank', this.ApiRequest.REQUEST_POST, { bank: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
